import { render, staticRenderFns } from "./VaProfileCard.vue?vue&type=template&id=0b7f9453&"
import script from "./VaProfileCard.vue?vue&type=script&lang=js&"
export * from "./VaProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./VaProfileCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports